import { ToggleBodyClass, FindAncestor } from '../helpers';

const nav = document.getElementById('desktop-nav');
const dropdown = document.getElementById('desktop-dropdown');
const mastHead = document.querySelector('.m-masthead');

function initNavActions() {
  const dropdownTriggers = document.querySelectorAll('[data-trigger]');
  const htmlTag = document.querySelector('html');

  function closeDropdown() {
    htmlTag.classList.remove('is-dropdown-visible');
    document.removeEventListener('click', handleDocumentClick, true);
    const activeNavItem = nav.querySelector('.selected');
    activeNavItem.classList.remove('selected');
  }

  function handleDocumentClick(event) {
    const test1 = FindAncestor(event.target, 'm-masthead');
    const test2 = FindAncestor(event.target, 'm-masthead-dropdown');

    if (test1 === null && test2 === null) {
      closeDropdown();
    }
  }

  function handleClick(event, id) {
    const activeItem = dropdown.getElementsByClassName('is-visible')[0];
    const activeNavItem = nav.querySelector('.selected');
    const { currentTarget } = event;

    if (currentTarget.classList.contains('selected')) {
      ToggleBodyClass('is-dropdown-visible');
      currentTarget.classList.remove('selected');
      return;
    }

    currentTarget.classList.add('selected');


    if (activeItem) activeItem.classList.remove('is-visible');
    if (activeNavItem) activeNavItem.classList.remove('selected');

    const el = document.getElementById(id);
    el.classList.add('is-visible');

    if (!document.querySelector('html').classList.contains('is-dropdown-visible')) {
      ToggleBodyClass('is-dropdown-visible');

      setTimeout(() => {
        document.addEventListener('click', handleDocumentClick, true);
      }, 25);
    }
  }

  [].map.call(dropdownTriggers, (trigger) => {
    trigger.addEventListener('click', event => handleClick(event, trigger.dataset.trigger));
  });
}

if (nav && mastHead) initNavActions();
